// @flow
import React, { PureComponent } from "react";
import HandicappingStorePP from "@tvg/atomic-ui/_templates/HandicappingStorePP";
import type { Device } from "@tvg/types/Device";
import type { BinaryFn } from "@tvg/types/Functional";
import tvgConf from "@tvg/conf";
import axios from "axios";
import { noop, get, attempt, slice } from "lodash";
import type {
  PurchasedProductItem,
  PurchasedProductGroup,
  PopularProduct
} from "@tvg/types/HandicappingStore";

type Props = {
  popularProductsIDs: string,
  onProductCallback: BinaryFn<string, ?string, void>,
  accountNumber: string,
  country: string,
  handicappingStorePurchases: boolean,
  device: Device,
  urlParams: string
};

type State = {
  isLoading: boolean,
  popularProducts: Array<PopularProduct>,
  purchasedProducts: Array<PurchasedProductGroup | PurchasedProductItem>
};

let isAllowedTrack = false;
const allowedCountries = ["USA", "CAN"];

const getServiceUrl = (
  environment: string,
  service: "PopularProducts" | "PurchasedProducts"
): string =>
  `https://tvgstore${
    environment === "qa" ? "-test" : ""
  }.equibase.com/Data.cfm/TvgStore/${service}/GetInfo?`;

export default class HadicappingStore extends PureComponent<Props, State> {
  static defaultProps = {
    popularProductsIDs: "",
    onProductCallback: noop,
    accountNumber: "1111",
    country: "",
    handicappingStorePurchases: false,
    device: "mobile",
    raceNumber: "1"
  };

  constructor(props: Props) {
    super(props);
    isAllowedTrack = allowedCountries.includes(this.props.country);

    this.state = {
      isLoading: isAllowedTrack,
      popularProducts: [],
      purchasedProducts: []
    };
  }

  componentDidMount() {
    return (
      isAllowedTrack &&
      Promise.all([this.getPopularProducts(), this.getPurchasedProducts()])
        .then((response) => {
          this.setState({
            popularProducts: response[0],
            purchasedProducts: response[1],
            isLoading: false
          });
        })
        .catch(() => {
          this.setState({ isLoading: false });
        })
    );
  }

  getPopularProducts = () => {
    const handicapPopularProducts = this.props.popularProductsIDs
      ? attempt(() => JSON.parse(this.props.popularProductsIDs))
      : [];

    const popularProducts =
      handicapPopularProducts.length > 5
        ? slice(handicapPopularProducts, 0, 5)
        : handicapPopularProducts;

    const popularProductsUrl = popularProducts
      .reduce(
        (productsUrl, product) => `${productsUrl}productId=${product.id}&`,
        getServiceUrl(tvgConf().environment, "PopularProducts")
      )
      .slice(0, -1);

    return axios
      .get(popularProductsUrl)
      .then((response) => get(response, "data", []));
  };

  getPurchasedProducts = () =>
    axios
      .get(getServiceUrl(tvgConf().environment, "PurchasedProducts"), {
        params: {
          accountId: this.props.accountNumber
        }
      })
      .then((response) => get(response, "data.purchases", []))
      .catch((error) => error);

  render() {
    return (
      <HandicappingStorePP
        isLoading={this.state.isLoading}
        purchasedProducts={this.state.purchasedProducts}
        popularProducts={this.state.popularProducts}
        isAllowedTrack={isAllowedTrack}
        onProductCallback={this.props.onProductCallback}
        handicappingStorePurchases={this.props.handicappingStorePurchases}
        device={this.props.device}
        handicapStoreUrl={`${this.props.urlParams}#handicap-store`}
      />
    );
  }
}
